Ext.define('SA.data.scatterplot.ScatterPlotDataMap', {
    limit: 10000,

    statics: {
        getEmptyData() {
            return {data: [], isPartial: false};
        }
    },

    constructor(cfg) {
        Object.assign(this, cfg);

        var query = SA.data.Query.from(this.createQueryConfig());

        this.dataPromise = query.run().then(() => {
            return {
                data: query.response.slice(0, this.limit),
                isPartial: query.response.length > this.limit
            };
        });
    },

    createQueryConfig() {
        var {attributes, geographicReleases, geographicUnit, limit, location} = this,
            fields = ['locationSeries', 'name', ...attributes],
            filter = ['and', ...attributes.map(attribute => ['<>', attribute, null])],
            where = [
                'and',
                ['=', 'geographicUnit', geographicUnit],
                ['in', 'geographicRelease', ...geographicReleases]
            ];

        if (this.filter) {
            filter.push(this.filter);
        }

        if (location.type === 'radius') {
            where.push(['radius', geographicUnit, location.radius, location.locationSeries[0]]);
        }
        else {
            where.push(['within', ...location.locationSeries]);
        }

        return {type: 'locations', fields, where, filter, limit: limit + 1};
    },

    getDataPromise() {
        return this.dataPromise;
    }
});